module.exports = __webpack_public_path__ + "img/session_bg.a410285f.png";